import styled from 'styled-components'

export const CollapseItemBox = styled.div<{ isActive: boolean }>`
  min-width: 3.5rem;
  background-color: ${(props) => (props.isActive ? 'var(--structure-menu-item-bg)' : 'inherit')};
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  word-break: break-word;
  transition: opacity ease 500ms;

  &:hover {
    background-color: var(--custom-color-lighter);
  }

  &:active {
    background-color: var(--gray-100) !important;
  }
`

export const CustomButton = styled.button`
  font-size: 0.875rem;
  outline: none;

  &:hover,
  &:active,
  &:focus,
  &.hot-button--active,
  &:active:focus {
    outline: none;
    border: none;
  }

  & .color-transparent {
    transition: color 1ms ease-out;
    color: inherit;

    &.active {
      color: transparent;
    }
  }
`

export const CommunitiesListAvatarBox = styled.div<{ isActive: boolean }>`
  background-color: ${(props) => (props.isActive ? 'var(--structure-menu-item-bg)' : 'inherit')};

  &:hover {
    background-color: var(--custom-color-lighter);
  }

  &:active {
    background-color: var(--gray-100) !important;
  }
`
